import Sticky from './Sticky';
export default Sticky;